import { getSupportedDevicesSync } from "./supportedDevicesStore";

type HidFilter = { vendorId?: number; productId?: number };
type HidDeviceLike = { vendorId: number; productId: number };

let supportedMouseFiltersCache: HidFilter[] | null = null;

function buildSupportedMouseFilters(): HidFilter[] {
  return Array.from(
    new Map(
      (
        getSupportedDevicesSync().mouse as Array<{
          vendorId?: number;
          productId?: number;
        }>
      )
        .filter(
          (item) =>
            typeof item.vendorId === "number" &&
            typeof item.productId === "number"
        )
        .map((item) => [
          `${item.vendorId}-${item.productId}`,
          { vendorId: item.vendorId, productId: item.productId },
        ])
    ).values()
  );
}

export function getMouseHidFilters(): HidFilter[] {
  if (!supportedMouseFiltersCache) {
    supportedMouseFiltersCache = buildSupportedMouseFilters();
  }
  return supportedMouseFiltersCache;
}

export function isSupportedMouseHidDevice(device: HidDeviceLike): boolean {
  return getMouseHidFilters().some(
    (filter) =>
      filter.vendorId === device.vendorId &&
      filter.productId === device.productId
  );
}
